/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Hook all ajax success

    // function disconnectUser() {

    // }
    function logOutUser() {
        window.location.href = gpr.loginpage;
    }

    // $(document).ajaxError(function (event, XMLHttpRequest, ajaxOptions) {
    //    console.log('HOOK');
    // });

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {

                /**
                 *  PUB HAUT SITE
                 **/
                var sideBarFlexslider;

                if ($('#top-ad-slider').length) {

                    $('#top-ad-slider').generateCarrousel({
                        position: 'TOP',
                        nonce: $(this).data('nonce'),
                        format: 'site',
                    });


                    sideBarFlexslider = $('#sidebar-ad-slider').generateCarrousel({
                        position: 'SIDEBAR',
                        nonce: $(this).data('nonce'),
                        format: 'site',
                    });
                }

                $(document).on('click', '.btn-close-popup', function (event) {
                    event.preventDefault();
                    $.magnificPopup.close();
                });

                //Popup info valider email, valider profil, première connexion
                $('.btn-popup').magnificPopup({
                    type: 'inline',
                    mainClass: 'mfp-zoom-in',
                    removalDelay: 500,
                    midClick: true,
                    closeBtnInside: true,
                });


                if ($('#page-popin').length) {
                    $.magnificPopup.open({
                        items: {
                            src: '#page-popin',
                            type: 'inline'
                        },
                        modal: true
                    });
                }


                $('.login_form').bind('keypress', function (e) {
                    if (e.keyCode === 13) {
                        $(this).find('.submit_loggedin').click();
                    }
                });



                $('.submit_loggedin').on('click', function (event) {
                    event.preventDefault();
                    var $btn = $(this);
                    $btn.button('loading');
                    var form = $(this).parent();
                    var nonce = form.data('nonce');


                    var l = form.find('.ulogin').val();
                    var p = form.find('.upassword').val();

                    if (p === '' || l === '') {
                        form.find('.error_login').html('Veuillez saisir vos identifiants');
                        $btn.button('reset');
                    } else {
                        $.ajax({
                            url: gpr.ajaxurl,
                            type: 'POST',
                            data: {
                                action: 'login',
                                _wpnonce: nonce,
                                login: l,
                                pwd: p
                            },
                            success: function (data) {
                                if (data.error === true) {
                                    form.find('.error_login').html(data.result);
                                } else {
                                    location.reload(); // then reload the page.(3)
                                }
                                $btn.button('reset');
                            }
                        });
                    }
                });

                //Slider partenaires
                $('.flexslider').flexslider({
                    animation: "slide",
                    // animationLoop: true,
                    slideshowSpeed: 3000,
                    controlNav: false,
                    itemWidth: 110,
                    itemMargin: 30,
                    minItems: 2,
                    maxItems: 5
                });

                $('input').iCheck({
                    checkboxClass: 'icheckbox_square-blue',
                    radioClass: 'iradio_square-blue'
                });

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired


                $(document).on('click', '.fold-button', function (event) {
                    event.preventDefault();
                    $(this).toggleClass('open');
                    $(this).next().slideToggle(300);
                    /* Act on the event */
                });

                $('.sameheight').matchHeight();

                $('.formulaire-icare li label').matchHeight({
                    byRow: true,
                    property: 'height',
                    target: null,
                    remove: false
                });

                // Affichage Partenaires
                // $('.flexslider').generateCarrouselPartenaires({
                //   position: 'PARRAIN',
                //   nonce: $(this).data('nonce'),
                //   format: 'site'
                // });

                // On vérifie au chargement si on vien du formulaire de calcule.
                // On affiche le tooltip sur le DFG
                // $(document).on('propertychange change', 'input#dfg', function () {
                //     $(this).checkDfg();
                // });

            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page

                var blueBlockHeight = $('.bloc-title').outerHeight();

                $(window).resize(function () {
                    blueBlockHeight = $('.bloc-title').outerHeight();
                    console.log(blueBlockHeight)
                });

                $('.bloc-title').click( function() {

                    var dropDownMenu = $(this).next();
                    var parentToExtend = $(this).parent();

                    // on ferme les autres sous menu ouvert
                    $('.panel-gpr').css('height', 'auto');
                    $('.panel-gpr .list-bloc-home').css('display', 'none');

                    dropDownMenu.toggle(0, function() {
                        var h = dropDownMenu.height();
                        if (dropDownMenu.is(":visible")) {
                            console.log('visible');
                            parentToExtend.height(blueBlockHeight + h);
                        }
                        console.log(h +' + ' + blueBlockHeight);
                    });

                    // dropDownMenu.slideToggle('fast', function () {
                    //     var h = dropDownMenu.height();
                    //     var currentH = parentToExtend.height();
                    //     console.log(currentH, h);
                    //     if (dropDownMenu.is(":visible")) {
                    //         console.log('visible');
                    //         parentToExtend.height(currentH - h);
                    //     } else {
                    //         console.log('not visible ....');
                    //         parentToExtend.height(currentH + h);
                    //     }
                    // });

                });
            },
            finalize: function () {
                $('#ad-homepage').generateCarrousel({
                    position: 'TOP',
                    nonce: $(this).data('nonce'),
                    format: 'homepage'
                });

                $(document).on('click', '.open-sub-menu', function (event) {
                    event.preventDefault();
                    // console.log(open);
                    $(this).parent().next().find('.home-sub-menu').toggle('fast');
                    /* Act on the event */
                });
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        'form_user_input': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // $('#birthdate').datetimepicker({
                //   // locale: 'fr',
                //   format: 'D MMMM YYYY',
                //   minDate: new Date(1930, 01,01),
                //   maxDate: moment().subtract(18, 'years')
                // });
                $('input[name=secteur]').on('ifChecked', function (event) {
                    // console.log('div.secteur-' + typeSecteur);
                    var typeSecteur = $(this, 'input').val();
                    $('div.secteur').hide();
                    $('div.secteur-' + typeSecteur).show();
                    $('div.secteur:not(secteur-' + typeSecteur + ') input').val('');
                    if (typeSecteur !== 'etablissement') {
                        $('#etablissement').select2({
                            theme: 'bootstrap'
                        }).val('');
                    }
                });

                //On coche les cases secteurs suivant s'il a des données dans l'un ou dans l'autre
                if ($("input[name=raisonSociale]").val() !== '') {
                    var rs = $("input[name=raisonSociale]").val();
                    $("input#secteur_2").iCheck('check');
                    $('#raisonSociale').val(rs);
                } else if ($("input[name=precisonSecteur]").val() !== '') {
                    var precisionSecteur = $("input[name=precisonSecteur]").val();
                    $("input#secteur_3").iCheck('check');
                    $('#precisonSecteur').val(precisionSecteur);
                } else if ($("input[name=zip]").val() !== '') {
                    $("input#secteur_1").iCheck('check');
                }

                //On coche les cases secteurs suivant s'il a des données dans l'un ou dans l'autre
                $(".list-origine .checked").parent().trigger('click');

            }
        },
        'page_template_template_page_profile': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {

                // Upload de fichier
                // console.log('upload');
                $('#justificatif').fileupload({
                    dataType: 'json',
                    start: function (e, data) {
                        $('#submit_form').prop('disabled', true);
                    },
                    change: function (e, data) {
                        $.each(data.files, function (index, file) {
                            $('#originalFilename').val(file.name);
                        });
                    },
                    progressall: function (e, data) {
                        var progress = parseInt(data.loaded / data.total * 100, 10);
                        $('#progress .bar').css(
                            'width',
                            progress + '%'
                        );
                    },
                    done: function (e, data) {
                        // console.log(data);
                        $.each(data.result.files, function (index, file) {
                            var originalFileName = $('#originalFilename').val();
                            $('.list-files-uploaded').html('<span class="clean-file-uploaded"><i class="fa fa-times"></i></span> ' + originalFileName);
                            $('#justificatif_value').val(file.name);
                        });
                        $('#progress .bar').css(
                            'width',
                            0 + '%'
                        );
                        $('#submit_form').prop('disabled', false);
                    }
                });

                $(document).on('click', '.clean-file-uploaded', function (event) {
                    event.preventDefault();
                    $('#justificatif_value').val('');
                    $('.list-files-uploaded').html('');
                    $('#progress .bar').css('width', '0');
                    /* Act on the event */
                });



            }
        },
        'page_template_template_register': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {

                // Upload de fichier

                $('#justificatif').fileupload({
                    dataType: 'json',
                    // add: function (e, data) {
                    //     $('.fileinput-button .txtbtn').html('<i class="fa fa-circle-o-notch  fa-spin"></i>');
                    //     $('#submit_form').addClass('disabled');
                    // },
                    start: function (e, data) {
                        $('#submit_form').prop('disabled', true);
                    },
                    change: function (e, data) {
                        $.each(data.files, function (index, file) {
                            $('#originalFilename').val(file.name);
                        });
                    },
                    progressall: function (e, data) {
                        var progress = parseInt(data.loaded / data.total * 100, 10);
                        $('#progress .bar').css(
                            'width',
                            progress + '%'
                        );
                    },
                    done: function (e, data) {
                        // console.log(data);
                        $.each(data.result.files, function (index, file) {
                            var originalFileName = $('#originalFilename').val();
                            $('.list-files-uploaded').html('<span class="clean-file-uploaded"><i class="fa fa-times"></i></span> ' + originalFileName);
                            $('#justificatif_value').val(file.name);
                        });
                        $('#progress .bar').css(
                            'width',
                            0 + '%'
                        );
                        $('#submit_form').prop('disabled', false);
                    }
                });

                $(document).on('click', '.clean-file-uploaded', function (event) {
                    event.preventDefault();
                    $('#justificatif_value').val('');
                    $('.list-files-uploaded').html('');
                    $('#progress .bar').css('width', '0');
                    /* Act on the event */
                });



            }
        },

        // About us page, note the change from about-us to about_us.
        'page_template_template_fonction_renale': {
            init: function () {
                // JavaScript to be fired on the about us page

                // $('#filed').on('click', function(event) {
                //   event.preventDefault();
                //   $('#age').val('67');
                //   $('#creatinemie').val('100');
                //   $('#poids').val('80');
                //   $('#taille').val('180');
                //   $('.form-group > .radio-inline:first-child').click();
                // });

                /**
                 *
                 * CALCULE DE LA FONCTION RENALE
                 *
                 **/
                $('#form_renal').keypress(function (e) {
                    if (e.which === 13 || e.wich === 0 || e.wich === 32) {
                        $("#submit-form-renal").click();
                    }
                });

                $('#submit-form-renal').on('click', function (event) {
                    event.preventDefault();
                    $('.msg').html('').hide();
                    var $btn = $(this);
                    // $btn.button('loading');

                    //On prépare le chargement en vidant les champs + bouton en attente
                    $("#results_cr").html('');
                    $(".results_msg").html('');


                    var data = $('#form_renal').serialize();

                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: data,
                        success: function (data) {
                            if (data.error === true) {

                                $('.form-group').removeClass('has-error');
                                $.each(data.error_msg, function (index, el) {
                                    $('input[name="' + index + '"]').closest('.form-group').addClass('has-error');
                                });

                                $('.msg').html('<ul></ul>').addClass('msg-error').show('fast');
                                $.each(data.error_msg, function (index, val) {
                                    /* iterate through array or object */
                                    $('.msg ul').append('<li>' + val + '</li>');

                                });

                            } else {

                                $('.form-group').removeClass('has-error');
                                //MUSTACHE.JS
                                var template_msg = $('#template_msg').html();
                                var renderer_msg = Mustache.render(template_msg, data);
                                $(".results_msg").html(renderer_msg);

                                json_result = data.content;
                                var template = $('#template_results').html();
                                var counter = 0;
                                var view = {
                                    r: json_result,
                                    odd_even: function () {
                                        return counter++ % 2 === 0 ? 'odd' : 'even';
                                    }
                                };
                                var renderer = Mustache.render(template, view);
                                $("#results_cr").html(renderer);
                            }
                            $('.sameheight').matchHeight();
                            $btn.button('reset');

                        }
                    });
                });
                // ./Fonction rénale

            },
            finalize: function () {}
        },

        'page_template_template_recherche_med': {
            init: function () {

                //on initialise les stats.
                var stats = {};
                var selectInstance;
                stats.effetsRenaux = false;

                //Bouton ouvrir le fold des fiches DCIS
                function getFiche(idFiche,idDci) {
                    //Loader
                    idDci = idDci || 0; // ligne permettant d'ajouter des paramètre option dans la fonction (idDci) en ES5...

                    $('#loader').show().slideTo({
                        target: '.fiche_dci'
                    });

                    stats.idFiche = idFiche;
                    var dfg = '';
                    var fonctionRenale = '';
                    if ($('.btn-search.active').length) {
                        fonctionRenale = $('.btn-search.active').data('value');
                    } else {
                        fonctionRenale = 'nondialyse';
                        dfg = $('input#dfg').val();
                        stats.dfg = dfg;
                    }

                    stats.typePatient = fonctionRenale;

                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            idFiche: idFiche,
                            _wpnonce: $('#_wpnonce').val(),
                            action: 'get_fiche',
                            fonctionRenale: fonctionRenale,
                            dfg: dfg,
                            typeSearch: $('#search_type').val()
                        },
                        success: function (data) {
                            console.log(data);
                            if(data.disconnected) {
                                logOutUser();
                            }
                            //MUSTACHE.JS
                            var search = data.fields[0].value;
                            // console.log($('#search_type').val());
                            displayBtnEffetsRenaux = $('#search_type').val() === 'effets_renaux' ? false : true;
                            displayBtnAdaptationPoso = $('#search_type').val() === 'effets_renaux' ? true : false;
                            console.log(displayBtnAdaptationPoso);
                            var templateFiche = $('#template_search_fiche').html();

                            var rendererFiche = '';


                            if (data.noresults !== '') {
                                rendererFiche = '<h2>' + gpr.no_result + '</h2>';
                            } else {
                                console.log(search);
                                var r = {
                                    'search_adaptation_poso': encodeURIComponent(search).replace(/%20/g, "+"),
                                    'fields': data.fields,
                                    'btn_effets_renaux': displayBtnEffetsRenaux,
                                    'btn_adaptation_posologique': displayBtnAdaptationPoso,
                                    'idFiche': idFiche,
                                };
                                console.log(r);
                                rendererFiche = Mustache.render(templateFiche, r);
                            }



                            $(".fiche_dci").html(rendererFiche).fieldHeight();

                            // on travail le bout lien

                            //On initialyse la popup Effets rénaux
                            //Popup effets renaux
                            $('.btn-effets-renaux').magnificPopup({
                                type: 'inline',
                                mainClass: 'mfp-zoom-in',
                                removalDelay: 500,
                                midClick: true,
                                closeBtnInside: true,
                                callbacks: {
                                    open: function () {
                                        $('#loader-popin').show();
                                        var idFiche = $('.btn-effets-renaux').data('idfiche');
                                        var nonce = $('.btn-effets-renaux').data('nonce');

                                        // var dfg = '';
                                        // var fonctionRenale = fonctionRenale
                                        // console.log(fonctionRenale);

                                        $.ajax({
                                            url: gpr.ajaxurl,
                                            type: 'POST',
                                            data: {
                                                action: 'get_fiche',
                                                idFiche: idFiche,
                                                _wpnonce: nonce,
                                                fonctionRenale: fonctionRenale,
                                                dfg: dfg,
                                                typeSearch: 'effets_renaux'
                                            },
                                            success: function (data) {
                                                if (data.disconnected) {
                                                    logOutUser();
                                                }

                                                if (data.fields === null) {
                                                    data.noeffetsrenaux = true;
                                                }
                                                var templateFiche = $('#template_search_fiche').html();
                                                var rendererFiche = Mustache.render(templateFiche, data);
                                                $('#fiche-popin .popin-content').html(rendererFiche).fieldHeight();

                                                //Stats sur btn effets renaux
                                                stats.effetsRenaux = true;
                                                statsEffetsRenaux = stats;
                                                statsEffetsRenaux.typePatient = '';
                                                s = JSON.stringify(statsEffetsRenaux);
                                                $.ajax({
                                                    url: gpr.ajaxurl,
                                                    type: 'POST',
                                                    data: {
                                                        action: 'stats_adaptationposo',
                                                        statistiques: s
                                                    }
                                                });
                                                stats.effetsRenaux = false;

                                            }
                                        }).always(function () {
                                            $('#loader-popin').hide();
                                        });
                                    },
                                    close: function () {
                                        $('#fiche-popin .popin-content').html('');
                                    }
                                }
                            });

                            $('.btn-adaptation-poso').magnificPopup({
                                type: 'inline',
                                mainClass: 'mfp-zoom-in',
                                removalDelay: 500,
                                midClick: true,
                                closeBtnInside: true,
                                callbacks: {
                                    open: function () {
                                        $('#loader-popin').show();
                                        var idFiche = $('.btn-adaptation-poso').data('idfiche');
                                        var nonce = $('.btn-adaptation-poso').data('nonce');

                                        // var dfg = '';
                                        // var fonctionRenale = fonctionRenale
                                        //    console.log(fonctionRenale);

                                        $.ajax({
                                            url: gpr.ajaxurl,
                                            type: 'POST',
                                            data: {
                                                action: 'get_fiche',
                                                idFiche: idFiche,
                                                _wpnonce: nonce,
                                                fonctionRenale: fonctionRenale,
                                                dfg: dfg,
                                                typeSearch: 'med'
                                            },
                                            success: function (data) {
                                                if (data.disconnected) {
                                                    logOutUser();
                                                }

                                                if (data.fields === null) {
                                                    data.noeffetsrenaux = true;
                                                }
                                                var templateFiche = $('#template_search_fiche').html();
                                                var rendererFiche = Mustache.render(templateFiche, data);
                                                $('#fiche-popin .popin-content').html(rendererFiche).fieldHeight();

                                                //Stats sur btn effets renaux
                                                stats.effetsRenaux = false;
                                                s = JSON.stringify(stats);
                                                $.ajax({
                                                    url: gpr.ajaxurl,
                                                    type: 'POST',
                                                    data: {
                                                        action: 'stats_adaptationposo',
                                                        statistiques: s
                                                    }
                                                });
                                                stats.effetsRenaux = true;

                                            }
                                        }).always(function () {
                                            $('#loader-popin').hide();
                                        });
                                    },
                                    close: function () {
                                        $('#fiche-popin .popin-content').html('');
                                    }
                                }
                            });

                            //On envoie les stats de consultation
                            // console.log(stats);
                            // console.log('Effets rénaux ?');
                            // console.log(stats.effetsRenaux);
                            // console.log(stats);
                            if(stats.effetsRenaux) {
                                stats.typePatient = '';
                                stats.dfg = '';
                            }
                            s = JSON.stringify(stats);

                            $.ajax({
                                url: gpr.ajaxurl,
                                type: 'POST',
                                data: {
                                    action: 'stats_adaptationposo',
                                    statistiques: s
                                }
                            });
                            // stats = {};

                        }
                    }).always(function () {
                        $('#loader').hide();
                    });
                }

                $(document).on('click', '#btn-go-adapt', function (e) {
                    e.preventDefault();
                    var s   = $(this).data('search');
                    var url = $(this).attr('href');
                    console.log(url);
                    url = url.substring(0, url.length - 1) + '?sdci=' + s;
                    console.log(url);
                    window.open(url);
                });

                //Format de la ligne Select2 en fonction du type renvoyé
                function formatDCI(dci) {
                    // console.log(dci);
                    if (!dci.id) {
                        return dci.text;
                    }
                    if (dci.type === 'nom_commercial') {
                        return '' + dci.text + '';
                    } else {
                        return dci.text;
                    }
                }

                // function formatDCISelected(dci_selected){
                //   console.log(dci_selected);
                //   return "ZZZZZ";
                // }
                // var mySelect2 = $("#search-field").select2({
                // console.log(gpr.language);

                var language_translation = {
                    inputTooShort: function (args) {
                        // args.minimum is the minimum required length
                        // args.input is the user-typed text
                        return "Veuillez saisir au moins 2 caractères";
                    },
                    // inputTooLong: function(args) {
                    //   // args.maximum is the maximum allowed length
                    //   // args.input is the user-typed text
                    //   return "You typed too much";
                    // },
                    errorLoading: function () {
                        return "";
                    },
                    loadingMore: function () {
                        return "";
                    },
                    noResults: function () {
                        return gpr.btn_no_result;
                    },
                    searching: function () {
                        return "Recherche en cours...";
                    },
                    maximumSelected: function (args) {
                        // args.maximum is the maximum number of items the user may select
                        return "";
                    }
                };


                selectInstance = $("#search-field").select2({
                    // allowClear: true,
                    minimumResultsForSearch: -1,
                    minimumInputLength: 2,
                    selectOnClose: true,
                    // language: gpr.language,
                    language: language_translation,
                    // tags: true,
                    allowClear: true,
                    placeholder: gpr.chooseDci,
                    theme: "bootstrap",
                    ajax: {
                        url: gpr.ajaxurl,
                        delay: 100,
                        cache: true,
                        dataType: 'json',
                        data: function (params) {
                            var query = {
                                q: params.term,
                                action: 'search_med',
                                _wpnonce: $('#_wpnonce').val(),
                            };
                            return query;
                        },
                        processResults: function (data, params) {
                            if (data.disconnected) {
                                logOutUser();
                            }
                            params.page = params.page || 1;
                            $('.results_dci div').html('');
                            return {
                                results: data.content,
                                pagination: {
                                    more: (params.page * 30) < data.total_count
                                }
                            };
                        },
                    },
                    cache: true,
                    escapeMarkup: function (markup) {
                        return markup;
                    }, // let our custom formatter work
                    // templateResult: formatDCI, // omitted for brevity, see the source of this page
                    // templateSelection: formatDCISelected // omitted for brevity, see the source of this page

                }).on("change", function (e) {

                    stats = {};
                    stats.effetsRenaux = false;

                    $('#loader').show();

                    $('.libelle_dci, .btns_dialyse, .btns_voie, .fiche_dci ').html('').show();
                    id = this.value;
                    if (id === '') {
                        $('#loader').hide();
                        return;
                    }

                    var type = 'dci';

                    //On récupère le texte du select pour le comparé au nom de la DCI afin de savori si nom commercial ou DCI pour afficher éventuellement le bouton
                    var nc = '';
                    var nc_value = $("#search-field").select2('data');
                    nc = nc_value[0].text;
                    // console.log(this.value);

                    //On vérifie si c'est un nom commercial (plusieurs id PIPE avec "|" : 125|589 ):
                    // partie 0 = idNomCommercialDci
                    // partie 1 = idDci
                    if (this.value.indexOf('|') > -1) {

                        ids = this.value.split('|');
                        id = ids[1];
                        // console.log(ids);
                        stats.idNc = parseInt(ids[0]);
                        stats.idDci = parseInt(ids[1]);

                    } else {
                        stats.idDci = parseInt(id);
                    }

                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            _wpnonce: $('#_wpnonce').val(),
                            id: id,
                            type: type,
                            action: 'get_dci'
                        },
                        success: function (data) {
                            if (data.disconnected) {
                                logOutUser();
                            }
                            if (data.error === true) {
                                //On affiche le block aucun résultat;
                                var tplNoResult = $('#template_search_noresult').html();
                                $('.fiche_dci').html(Mustache.render(tplNoResult, data));
                            } else {
                                // console.log(data);
                                // console.log(data.libelleDci + ' | ' + nc )
                                // On affiche la pub DCI si besoin;
                                // console.log(data.displayPub);
                                if (data.displayPub) {
                                    if (data.displayPub.idPub != null) {
                                        $('#sidebar-ad-slider').addSlidePubDci({
                                            id: data.displayPub.idPub,
                                            link: data.displayPub.link,
                                            nonce: data.displayPub.nonce,
                                            durationPub: data.displayPub.duration,
                                        });
                                    }
                                }


                                // MUSTACHE.JS  Bouton dialyse DFG HDDV , etc.
                                var templateBtnDialyse = $('#template_search_dialyse').html();
                                var renderedBtnDialyse = Mustache.render(templateBtnDialyse, data);

                                // MUSTACHE.JS bouton des voies
                                var templateBtnVoie = $('#template_search_voie').html();
                                var renderedBtnVoie = Mustache.render(templateBtnVoie, data);

                                var type_search = $('#search_type').val();

                                //console.log(renderedBtnVoie);
                                // console.log(data);
                                // Le nom sélectionné != du libellé DCI donc on a un nom commercial, et on affiche le bouton
                                // console.log(data.libelleDci +'+'+nc);
                                if (data.libelleDci !== nc) {

                                    $('h1.libelle_dci').html(data.libelleDci).hide();

                                    var templateBtnNCDCI = $('#template_btn_ncdci').html();
                                    var renderedBtnNCDCI = Mustache.render(templateBtnNCDCI, {
                                        'nom_commercial': nc,
                                        'dci': data.libelleDci
                                    });
                                    $(".btn_ncdci").html(renderedBtnNCDCI);
                                    if (type_search === 'effets_renaux') {
                                        stats.effetsRenaux = true;
                                        $(".btns_voie").html(renderedBtnVoie);
                                        if (!data.indication && !data.voiesAdmin /*&& !isNaN(data.idFiche)*/ ) {

                                            getFiche(data.idFiche, data.idDci);
                                            $('.fiche_dci').hide();

                                        }
                                        // $('.list_voies_admin').hide();
                                    } else {

                                        $(".btns_dialyse").html(renderedBtnDialyse).hide();
                                        $(".btns_voie").html(renderedBtnVoie);

                                    }

                                } else {
                                    $('h1.libelle_dci').html(data.libelleDci).show();
                                    if (type_search === 'effets_renaux') {
                                        stats.effetsRenaux = true;
                                        $(".btns_voie").html(renderedBtnVoie).slideTo({
                                            target: '.btns_voie'
                                        });
                                        //&& !isNaN(data.idFiche)
                                        if (!data.indication && !data.voiesAdmin) {
                                            getFiche(data.idFiche);
                                        } else {
                                            $('.list_voies_admin').show();
                                        }

                                    } else {

                                        $(".btns_dialyse").html(renderedBtnDialyse).slideTo({
                                            target: '.btns_dialyse'
                                        });
                                        if (!data.indication && !data.voiesAdmin) {
                                            // getFiche(data.idFiche);
                                        } else {
                                            $(".btns_voie").html(renderedBtnVoie);
                                        }
                                    }
                                }

                                //On active la fonctionalité de  tooltip sur la DFG :
                                $('#dfg[data-toggle="tooltip"]').tooltip({
                                    trigger: 'manual'
                                });

                            }
                        }
                    }).always(function () {
                        $('#loader').hide();
                    }); // fin ajax


                }); //Fin select2 Change

                //Function for init select2seach
                function select2_search($el, term) {
                    $el.select2('open');

                    // Get the search box within the dropdown or the selection
                    // Dropdown = single, Selection = multiple
                    var $search = $el.data('select2').dropdown.$search || $el.data('select2').selection.$search;
                    // This is undocumented and may change in the future

                    $search.val(term);
                    $search.trigger('keyup');
                }

                var initSearch = $('form.big-select').data('currentvaluesearch');
                if( initSearch) {
                    select2_search(selectInstance, initSearch);
                }



                $("#search-field").data("select2").on("results:message", function () {
                    this.dropdown._positionDropdown();
                });

                // console.log($("#search-field").data("select2"));
                // mySelect2.data('select2').$results.addClass('big-select');

                $(document).on('click', '.btn-nctodci', function (event) {
                    event.preventDefault();
                    var type_search = $('#search_type').val();
                    if (type_search === "effets_renaux") {
                        // Correction du bug qui affiche le titre des voies avec une valeur vide et la réponse "Aucun resultat disponible"

                        if ($('.list-btn-voies li').length === 0) {
                            $('.list_voies_admin h2').html('');
                        }

                        $("h1.libelle_dci, .btns_dialyse, .btns_voie, .fiche_dci, .list_voies_admin").show().slideTo({
                            target: '.btns_dialyse'
                        });


                    } else {
                        // console.log('TEST');
                        $("h1.libelle_dci, .btns_dialyse").show().slideTo({
                            target: '.btns_dialyse'
                        });
                        if ($('.list-btn-voies li').length === 0) {
                            //Lorsqu'on a une DCI qui n' pas de fiche ex : Diffu K
                            $('.list_voies_admin h2').html(gpr.no_result);
                        }


                    }
                });


                //Affiche la fiche btn_standard
                $(document).on('click', '.get_fiche', function (event) {
                    event.preventDefault();

                    var displayNext = false;

                    if ($(this).hasClass('btn-dfg')) {
                        displayNext = $(this).checkDfg();
                    } else {
                        displayNext = true;
                    }

                    if (displayNext) {
                        $(".get_fiche").removeClass('active');
                        $(this).addClass('active');
                        $(".fiche_dci").html('');
                        var idFiche = $(this).data('idfiche');
                        getFiche(idFiche);
                    }
                });

            }
        },

        'page_template_template_interaction_med': {
            init: function () {
                // console.log('Interaction');
                //RAZ des recherches :
                var stats = {}; // On initalize les stats
                stats.idItems = [];
                // stats.idDci = '';
                // stats.idNc  = '';

                var globalDci;
                var listDciInteraction = [];
                var nbChoice = 2;
                var language_translation = {
                    inputTooShort: function (args) {
                        return "";
                    }
                };

                $(document).on('click', '.btn-reset', function (event) {
                    event.preventDefault();
                    listDciInteraction = [];

                    stats = {};
                    stats.idItems = [];

                    $('.search-field').eq(0).select2('val', 'All');
                    $('.search-field').eq(1).select2('val', 'All');
                    $('.search-field').eq(0).prop('disabled', false);
                    $('.search-field').eq(1).prop('disabled', false);

                    $('.btn_ncdci, .libelle_dci, .btns_dialyse, .fiche_dci').html('');
                    $('#loader').hide();

                    // on vide les pubs de la sidebar
                    $('#sidebar-ad-slider li').each(function (index, el) {
                        $('#sidebar-ad-slider').data('flexslider').removeSlide(index);
                    });

                });

                function getInteraction(idDci) {

                    // console.log(idDci);
                    // console.log(stats);
                    $(".fiche_dci").html('');
                    if (idDci.length === nbChoice) {
                        $.ajax({
                            url: gpr.ajaxurl,
                            type: 'POST',
                            data: {
                                ids: JSON.stringify(idDci),
                                _wpnonce: $('#_wpnonce').val(),
                                action: 'get_interaction'
                            },
                            success: function (data) {
                                if (data.disconnected) {
                                    logOutUser();
                                }
                                // console.log('RETOUR GET DCI : ');
                                // console.log(data);
                                // console.log('FIN RETOUR GET DCI');
                                $('.search-field').eq(0).prop('disabled', true);
                                $('.search-field').eq(1).prop('disabled', true);

                                var templateFiche = $('#template_search_fiche').html();
                                var rendererFiche;
                                var result_final = '';

                                if (data === null || data.hasOwnProperty('error')) {
                                    var templateNoResult = $('#template_no_interactions').html();
                                    rendererNoResult = Mustache.render(templateNoResult);
                                    $(".fiche_dci").html(rendererNoResult);
                                } else {
                                    fields = data.fields;
                                    nb_elem = fields.length;
                                    $.each(fields, function (i, item) {

                                        hideb = true;
                                        rendererFiche = Mustache.render(templateFiche, {
                                            'fields': item,
                                            'hide_button': hideb
                                        });
                                        result_final = result_final + rendererFiche;

                                    });
                                    $('.fiche_dci').append(result_final).fieldHeight();
                                }



                                //On envoie les stats de consultation
                                s = JSON.stringify(stats);
                                // console.log("envoie des stats : ");
                                // console.log(s);
                                $.ajax({
                                    url: gpr.ajaxurl,
                                    type: 'POST',
                                    data: {
                                        action: 'stats_interactionsmed',
                                        statistiques: s
                                    }
                                });

                            }
                        });

                    } else {
                        // console.log('il manque des DCIS ou il y en a trop ...');
                    }

                }

                //Recherche PAR MEDICAMENT POUR UNE INTERACTION
                $(".search-field").select2({
                    // allowClear: true,
                    minimumResultsForSearch: -1,
                    minimumInputLength: 2,
                    selectOnClose: true,
                    language: gpr.language,
                    placeholder: gpr.chooseDci,
                    theme: "bootstrap",
                    ajax: {
                        url: gpr.ajaxurl,
                        delay: 100,
                        cache: true,
                        dataType: 'json',
                        type: 'POST',
                        data: function (params) {
                            var query = {
                                q: params.term,
                                action: 'search_med',
                                interactions: true,
                                _wpnonce: $('#_wpnonce').val()
                            };
                            return query;
                        },
                        processResults: function (data, params) {
                            if (data.disconnected) {
                                logOutUser();
                            }
                            params.page = params.page || 1;
                            //$('.results_dci div').html('') ;
                            return {
                                results: data.content,
                                pagination: {
                                    more: (params.page * 30) < data.total_count
                                }
                            };
                        },
                    },
                    cache: true,
                    escapeMarkup: function (markup) {
                        return markup;
                    }, // let our custom formatter work
                    // templateResult: formatDCI, // omitted for brevity, see the source of this page
                    // templateSelection: formatDCISelected // omitted for brevity, see the source of this page

                }).on("change", function (e) {
                    // console.log("interaction change");
                    $('.fiche_dci').hide();
                    var select_index = $(this).parent().parent().index();

                    $('#loader').show();

                    id = this.value;
                    // console.log('id : ' + id);
                    if (id === '') {
                        $('#loader').hide();
                        return;
                    }
                    var type = 'dci';

                    //on prépare les zones pour les bouton NomCommercial to DCI
                    // console.log($('.container-nctodci').length);
                    if ($('.container-nctodci').length === 0) {
                        for (var i = 1; i <= nbChoice; i++) {
                            $('.btn_ncdci').append(' <div class="container-nctodci"></div>');
                        }
                    }
                    $('.btn_ncdci div').eq(select_index).html();


                    //On récupère le texte du select pour le comparé au nom de la DCI afin de savori si nom commercial ou DCI pour afficher éventuellement le bouton
                    var nc = '';
                    var nc_value = $(this).select2('data');
                    nc = nc_value[0].text;

                    // On vérifie si c'est un nom commercial (plusieurs id PIPE avec "|" : 125|589 ):
                    // partie 0 = idNomCommercialDci
                    // partie 1 = idDci

                    if (this.value.indexOf('|') > -1) {

                        ids = this.value.split('|');
                        id = ids[1];
                        stats.idItems.push([parseInt(ids[1]), parseInt(ids[0])]);

                    } else {
                        stats.idItems.push([parseInt(id), '']);
                    }


                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            _wpnonce: $('#_wpnonce').val(),
                            id: id,
                            type: type,
                            action: 'get_dci'
                        },
                        success: function (data) {
                            if (data.disconnected) {
                                logOutUser();
                            }
                            if (data.error) {
                                // console.log('error');
                            } else {

                                var type_search = $('#search_type').val();
                                var templateBtnNCDCI;
                                var renderedBtnNCDCI;


                                if (data.displayPub) {
                                    if (data.displayPub.idPub !== null) {
                                        $('#sidebar-ad-slider').addSlidePubDci({
                                            id: data.displayPub.idPub,
                                            link: data.displayPub.link,
                                            nonce: data.displayPub.nonce,
                                            durationPub: data.displayPub.duration,
                                        });
                                    }
                                }

                                // Le nom sélectionné != du libellé DCI donc on a un nom commercial, et on affiche le bouton
                                if (data.libelleDci !== nc) {

                                    templateBtnNCDCI = $('#template_btn_ncdci').html();
                                    renderedBtnNCDCI = Mustache.render(templateBtnNCDCI, {
                                        'nom_commercial': nc,
                                        'dci': data.libelleDci
                                    });

                                }

                                // On regarde si l'utilisateur à déjà sélectionné 2 dcis :
                                // console.log(listDciInteraction);
                                if (listDciInteraction.length >= nbChoice) {

                                    listDciInteraction[select_index] = data.idDci;
                                    $('h1.libelle_dci div').eq(select_index).html(data.libelleDci);

                                    // Le nom sélectionné != du libellé DCI donc on a un nom commercial, et on affiche le bouton
                                    if (data.libelleDci !== nc) {
                                        templateBtnNCDCI = $('#template_btn_ncdci').html();
                                        renderedBtnNCDCI = Mustache.render(templateBtnNCDCI, {
                                            'nom_commercial': nc,
                                            'dci': data.libelleDci
                                        });
                                        $(".btn_ncdci .container-nctodci").eq(select_index).html(renderedBtnNCDCI);
                                        $('h1.libelle_dci div').eq(select_index).hide();
                                    }


                                } else {

                                    listDciInteraction.push(data.idDci);
                                    $('h1.libelle_dci').append('<div>' + data.libelleDci + '</div>');
                                    $(".btn_ncdci .container-nctodci").eq(select_index).html(renderedBtnNCDCI);

                                    // Le nom sélectionné != du libellé DCI donc on a un nom commercial, et on affiche le bouton
                                    if (data.libelleDci !== nc) {
                                        templateBtnNCDCI = $('#template_btn_ncdci').html();
                                        renderedBtnNCDCI = Mustache.render(templateBtnNCDCI, {
                                            'nom_commercial': nc,
                                            'dci': data.libelleDci
                                        });
                                        $(".btn_ncdci .container-nctodci").eq(select_index).html(renderedBtnNCDCI);
                                        $('h1.libelle_dci div').eq(select_index).hide();
                                    }

                                }

                                // console.log('dci in array :' + listDciInteraction);
                                $('.btn-reset').show();
                                if (listDciInteraction.length === nbChoice) {
                                    getInteraction(listDciInteraction);
                                    if ($(".btn-nctodci.active").length === $(".btn-nctodci").length) {
                                        $('.fiche_dci').show();
                                    }
                                }


                            }
                        }
                    }).always(function () {
                        $('#loader').hide();
                    });

                }); //Fin select2 Change
                $(".search-field").data("select2").on("results:message", function () {
                    this.dropdown._positionDropdown();
                });

                $(document).on('click', '.btn-nctodci', function (event) {
                    event.preventDefault();
                    var indexBtn = $(this).parent().index();
                    $(this).addClass('active');
                    $("h1.libelle_dci div").eq(indexBtn).show();
                    // console.log( $(".btn-nctodci.active").length + '##' + $(".btn-nctodci").length );
                    if ($(".btn-nctodci.active").length === $(".btn-nctodci").length) {
                        $('.fiche_dci').show();
                    }
                });



            }
        },

        'page_template_template_analyse_ordo': {
            init: function () {
                var maxDci = 7;
                var stats = {}; // On initalize les stats
                stats_partial = []; //Tableau temporaire pour ajout id NC lors de la selection // array( idDci , idNomCommercialDci , idFicheDci )

                $(document).on('click', '.remove_dci', function (event) {
                    event.preventDefault();
                    $(this).parent().remove();
                    $(".list-dci-title").trigger('contentChanged');
                });


                $(document).on('click', '.btn-nctodci', function (event) {
                    event.preventDefault();
                    if ($('.list-dci-title li:not(.toshow)').length >= maxDci) {
                        return;
                    }

                    var idFiche = $(this).data('iddci');
                    $('ul.list-dci-title li[data-idfiche="' + idFiche + '"]').removeClass('toshow');
                    $(this).parent().html(''); // on supprime le bouton
                    $(".list-dci-title").trigger('contentChanged');
                });


                $(document).on('click', '.list-btn-voies .get_fiche', function (event) {
                    event.preventDefault();
                    // console.log('click');
                    if ($('.list-dci-title li:not(.toshow)').length >= maxDci) {
                        return;
                    }
                    $('ul.list-dci-title').append('<li data-idfiche="' + $(this).data('idfiche') + '" data-iddci="' + $(this).data('iddci') + '"  data-idnc="' + $(this).data('idnc') + '" ><a class="remove_dci"><span class="fa fa-close"></span></a>' + $(this).text() + '</li>');
                    $(".list-dci-title").trigger('contentChanged');

                    $('.list_voies_admin').html(''); // on supprime les voies d'admin

                });

                $(document).on('click', '.btn-search, #btn_submit_dfg', function (event) {
                    event.preventDefault();
                    //console.log('Click search analyse ordonnance');
                    //console.log(stats);

                    $('.fiche_dci').html('');
                    $(".btn-search, .bloc-dfg").removeClass('active');
                    $(this).closest('.bloc-dialyse').addClass('active');
                    var displayNext = false;
                    var test = '';
                    if ($(this).hasClass('btn-dfg')) {
                        test = 'btndfg';
                        displayNext = $(this).checkDfg();
                    } else {
                        displayNext = true;
                    }
                    //console.log('displayNext : ' + displayNext + '|'+test);

                    //On affiche le résultat ! car DFG ou autre bouton OK
                    if (displayNext) {

                        $('#loader').show();

                        $('.list_voies_admin').show();
                        $(".fiche_dci").html('');
                        ids = [];
                        var stats_finales = [];
                        //On recupere la liste des fiches :
                        $('.list-dci-title li').each(function (index) {
                            id_fiche = $(this).data('idfiche');
                            id_dci = $(this).data('iddci');
                            id_nc = $(this).data('idnc');
                            stats_finales.push([id_dci, id_nc, id_fiche]);
                            ids.push(id_fiche);
                        });
                        // console.log(stats_finales);
                        // ========================================================================================================
                        var fonctionRenale = $(this).data('value');
                        var dfg = $('input#dfg').val();
                        $.ajax({
                            url: gpr.ajaxurl,
                            type: 'POST',
                            data: {
                                idFiche: JSON.stringify(ids),
                                _wpnonce: $('#_wpnonce').val(),
                                action: 'get_fiche',
                                fonctionRenale: fonctionRenale,
                                dfg: dfg,
                                typeSearch: 'ordonnance'
                            },
                            success: function (data) {
                                if (data.disconnected) {
                                    logOutUser();
                                }
                                //MUSTACHE.JS
                                // console.log(data);
                                if (data === null || data.hasOwnProperty('error')) {
                                    var templateNoResult = $('#template_ordonance_noresult').html();
                                    rendererNoResult = Mustache.render(templateNoResult);
                                    $(".fiche_dci").html(rendererNoResult);
                                } else {
                                    fields = data.fields;
                                    nb_elem = data.fields.length;
                                    var templateFiche = $('#template_search_fiche').html();
                                    var result_final = '';
                                    $.each(fields, function (i, item) {
                                        // console.log(item);
                                        hideb = i + 1 === nb_elem ? false : true; // on affiche le bouton qu'a la fin de la boucle.
                                        hideb = true;
                                        if (item.hasOwnProperty("noresults") && item.noresults !== '') {
                                            rendererFiche = '<div class="fiche_dci"><div class="info_title">' + item.noresults + '</div></div>';
                                        } else {
                                            rendererFiche = Mustache.render(templateFiche, {
                                                'fields': item,
                                                'hide_button': hideb
                                            });
                                        }
                                        // rendererFiche = Mustache.render(templateFiche, {'fields':item, 'hide_button': hideb} );
                                        result_final = result_final + rendererFiche;
                                    });
                                    $('.fiche_dci').html(result_final).fieldHeight();
                                    //console.log(result_final);

                                    //on initialize les popins "Voir la fiche" _dci_row
                                    var idFicheBtn;
                                    $('.btn-fiche').magnificPopup({
                                        type: 'inline',
                                        mainClass: 'mfp-zoom-in',
                                        removalDelay: 500,
                                        midClick: true,
                                        closeBtnInside: true,
                                        callbacks: {
                                            open: function () {
                                                $('#loader-popin').show();
                                                var dfg = '';
                                                var fonctionRenale = '';
                                                if ($('.btn-search.active').length) {
                                                    fonctionRenale = $('.btn-search.active').data('value');
                                                } else {
                                                    fonctionRenale = 'nondialyse';
                                                    dfg = $('input#dfg').val();
                                                }
                                                idFicheB = this.st.el.attr('data-idfiche');
                                                $.ajax({
                                                    url: gpr.ajaxurl,
                                                    type: 'POST',
                                                    data: {
                                                        action: 'get_fiche',
                                                        idFiche: idFicheB,
                                                        _wpnonce: $('#_wpnonce').val(),
                                                        fonctionRenale: fonctionRenale,
                                                        dfg: dfg,
                                                        typeSearch: 'popup_dci'
                                                    },
                                                    success: function (data) {
                                                        if (data.disconnected) {
                                                            logOutUser();
                                                        }
                                                        //MUSTACHE.JS

                                                        // console.log($('#search_type').val());
                                                        var templateFiche = $('#template_search_fiche').html();
                                                        var rendererFiche = Mustache.render(templateFiche, data);
                                                        $('#fiche-popin .popin-content').html(rendererFiche).fieldHeight();

                                                        // STATS ---------------------------------------------------
                                                        stats.idFiche = idFicheB;

                                                        idDci = $('.list-dci-title [data-idfiche="' + idFicheB + '"]').data('iddci');
                                                        idNc = $('.list-dci-title [data-idfiche="' + idFicheB + '"]').data('idnc');
                                                        stats.idDci = idDci !== 'undefined' ? idDci : '';
                                                        stats.idNc = idNc !== 'undefined' ? idNc : '';
                                                        if ($('.btn-search.active').length) {
                                                            stats.dfg = '';
                                                        } else {
                                                            stats.dfg = dfg;
                                                        }
                                                        if (stats.hasOwnProperty('data')) {
                                                            delete stats.data;
                                                        }
                                                        stats.typePatient = fonctionRenale;
                                                        stats.effetsRenaux = false;
                                                        s = JSON.stringify(stats);
                                                        $.ajax({
                                                            url: gpr.ajaxurl,
                                                            type: 'POST',
                                                            data: {
                                                                action: 'stats_adaptationposo',
                                                                statistiques: s
                                                            }
                                                        });

                                                        stats = {};



                                                    }
                                                }).always(function () {
                                                    $('#loader-popin').hide();
                                                });
                                            },
                                            close: function () {
                                                $('#fiche-popin .popin-content').html('');
                                            }
                                        }
                                    });

                                    //On affiche les stats
                                    //On envoie les stats de consultation
                                    stats.typePatient = fonctionRenale;
                                    stats.dfg = dfg;
                                    stats.data = stats_finales;

                                    s = JSON.stringify(stats);
                                    // console.log('stats ordonnance');
                                    // console.log(stats);
                                    $.ajax({
                                        url: gpr.ajaxurl,
                                        type: 'POST',
                                        data: {
                                            action: 'stats_ordonnance',
                                            statistiques: s
                                        }
                                    });

                                }

                            }
                        }).always(function () {
                            $('#loader').hide();
                        });
                    } //Fin if displayNext

                });


                //On regarde les changements de la div list dci
                $('.list-dci-title').bind("contentChanged", function () {


                    $('#loader').show();
                    $('.fiche_dci').html('');
                    if ($('.list-dci-title li:not(.toshow)').length >= 0) {
                        $('.ordonnance_actions').css('opacity', 1);
                    }

                    //On limite le nombre de DCI à ajouter dans l'ordonnance à 7
                    if ($('.list-dci-title li:not(.toshow)').length >= maxDci) {
                        $("#search-field").prop("disabled", true);
                    } else {
                        $("#search-field").prop("disabled", false);
                    }

                    //On affiche les bouton d'affichages a partir de 2 élements vibles
                    if ($('.list-dci-title li:not(.toshow)').length >= 1) {
                        // MUSTACHE.JS  Bouton dialyse DFG HDDV , etc.
                        var templateBtnDialyse = $('#template_ordonnance_dialyse').html();
                        var renderedBtnDialyse = Mustache.render(templateBtnDialyse);
                        $(".btns_dialyse").html(renderedBtnDialyse).show();
                        $('#dfg[data-toggle="tooltip"]').tooltip({
                            trigger: 'manual'
                        });

                    } else {
                        $(".btns_dialyse").html('');
                    }
                    $('.nb_dci').html($('.list-dci-title li:not(.toshow)').length); // on met a jour le nombre de DCI
                    $('#loader').hide();

                });

                $(document).on('click', '#empty_list', function (event) {
                    event.preventDefault();
                    $('.fiche_dci, .btns_dialyse, .list-dci-title').html('');
                    $("#search-field").select2('val', '');
                    $(".list-dci-title").trigger('contentChanged');

                    //On vide la sidebar de pub
                    $('#sidebar-ad-slider li').each(function (index, el) {
                        $('#sidebar-ad-slider').data('flexslider').removeSlide(index);
                    });

                    $(this).parent().css('opacity', 0);


                    stats = {}; // On initalize les stats
                    stats.idItems = [];
                    stats_partial = [];

                    /* Act on the event */
                });

                var language_translation = {};

                //   //Recherche PAR MEDICAMENT
                $("#search-field").select2({
                    // allowClear: true,
                    minimumResultsForSearch: -1,
                    minimumInputLength: 2,
                    selectOnClose: true,
                    language: gpr.language,
                    theme: "bootstrap",
                    ajax: {
                        url: gpr.ajaxurl,
                        delay: 100,
                        cache: true,
                        dataType: 'json',
                        data: function (params) {
                            var query = {
                                q: params.term,
                                action: 'search_med',
                                _wpnonce: $('#_wpnonce').val()
                            };
                            return query;
                        },
                        processResults: function (data, params) {
                            if (data.disconnected) {
                                logOutUser();
                            }
                            params.page = params.page || 1;
                            // $('.results_dci div').html('') ;
                            return {
                                results: data.content,
                                pagination: {
                                    more: (params.page * 30) < data.total_count
                                }
                            };
                        },
                    },
                    cache: true,
                    escapeMarkup: function (markup) {
                        return markup;
                    }, // let our custom formatter work
                    // templateResult: formatDCI, // omitted for brevity, see the source of this page
                    // templateSelection: formatDCISelected // omitted for brevity, see the source of this page
                }).on("change", function (e) {

                    $('#loader').show();

                    if ($('.list-dci-title li:not(.toshow)').length >= maxDci) {
                        $('#loader').hide();
                        alert("Vous êtes limité à " + maxDci + " elements");
                        return;
                    }

                    // stats_partial = []; // on remet a zero la variable temp.

                    // $('.toshow').remove();
                    // $('.libelle_dci, .btns_dialyse, .btns_voie, .fiche_dci ').html('');


                    //on vient changer le selecte, on vérifie qu'il ne soit pas vide (car remise a zero entre chque choix de DCI )
                    if (this.value.length > 0) {
                        id = this.value;
                        var type = 'dci';

                        //console.log( "VALUE : " + this.value );

                        var templateBtnVoie;
                        var renderedBtnVoie;

                        var isNomCommercial = false;
                        //on traite idDci vs idNomCommercialDci
                        // API : iddci, idcommercial, idfiche
                        if (this.value.indexOf('|') > -1) {
                            isNomCommercial = true;
                            var nc = '';
                            var nc_value = $(this).select2('data');
                            nc = nc_value[0].text;
                            ids = this.value.split('|');
                            id = ids[1];

                            stats_partial = ['', parseInt(ids[0]), '']; // on laisse vide pour identifier diférence ente DCI & NC

                        } else {
                            stats_partial = [parseInt(id), '', ''];
                        }

                        // if(id.substring(0, 3) === 'nc_') {
                        //     id = id.substring(3);
                        //     // console.log('traitement nom Commercial');
                        //     isNomCommercial  = true;
                        //     var nc = '';
                        //     var nc_value = $(this).select2('data');
                        //     nc = nc_value[0].text;
                        // }

                        // console.log(nc);
                        type = 'dci';
                        $.ajax({
                            url: gpr.ajaxurl,
                            type: 'POST',
                            data: {
                                _wpnonce: $('#_wpnonce').val(),
                                id: id,
                                type: type,
                                action: 'get_dci'
                            },
                            success: function (data) {
                                if (data.disconnected) {
                                    logOutUser();
                                }
                                // console.log('ZZ');
                                if (data.error === true) { //On affiche le block aucun résultat;
                                    var tplNoResult = $('#template_search_noresult').html();
                                    $('.fiche_dci').html(Mustache.render(tplNoResult, data));

                                } else {
                                    if (data.displayPub) {
                                        if (data.displayPub.idPub != null) {
                                            $('#sidebar-ad-slider').addSlidePubDci({
                                                id: data.displayPub.idPub,
                                                link: data.displayPub.link,
                                                nonce: data.displayPub.nonce,
                                                durationPub: data.displayPub.duration,
                                            });
                                        }
                                    }
                                    // console.log(data);
                                    // idFiche = parseInt( data.idFiche );
                                    // stats_partial.push( idFiche ); //stats
                                    // stats.idItems.push( stats_partial );

                                    //On ajoute les valeurs des idc_nc / idDci pour les récupérer a la fin pour les stats
                                    data.data_iddci = stats_partial[0];
                                    data.data_idnc = stats_partial[1];

                                    var templateBtnNCDCI = $('#template_btn_ncdci').html();
                                    var renderedBtnNCDCI = Mustache.render(templateBtnNCDCI, {
                                        'nom_commercial': nc,
                                        'dci': data.libelleDci,
                                        'iddci': data.idFiche
                                    });
                                    if (!jQuery.isEmptyObject(data.indication)) {

                                        if (isNomCommercial) {
                                            $(".btn_ncdci").html(renderedBtnNCDCI);
                                            // console.log("idFiche quand NC : ");
                                            $("ul.list-dci-title li[data-idfiche='" + data.idFiche + "']").addClass('toshow');
                                            $(".list_voies_admin").hide();
                                        }

                                        $.each(data.indication, function (i, item) {
                                            data.indication[i].libelle = data.libelleDci + ' - ' + data.indication[i].libelle;
                                        });

                                        templateBtnVoie = $('#template_search_voie').html();
                                        // data.data_iddci = stats_partial[0];
                                        // data.data_idnc  = stats_partial[1];
                                        // console.log('EMPTY VOIES INDICATION');
                                        // console.log(data);
                                        renderedBtnVoie = Mustache.render(templateBtnVoie, data);
                                        $(".btns_voie").html(renderedBtnVoie);
                                        $(".list_voies_admin").show();

                                    } else if (!jQuery.isEmptyObject(data.voiesAdmin)) {

                                        $.each(data.voiesAdmin, function (i, item) {
                                            data.voiesAdmin[i].libelle = data.libelleDci + ' - ' + data.voiesAdmin[i].libelle;
                                        });

                                        templateBtnVoie = $('#template_search_voie').html();
                                        // data.data_iddci = stats_partial[0];
                                        // data.data_idnc  = stats_partial[1];
                                        // console.log('EMPTY VOIES ADMIN');
                                        // console.log(data);
                                        renderedBtnVoie = Mustache.render(templateBtnVoie, data);
                                        $(".btns_voie").html(renderedBtnVoie);
                                        $(".list_voies_admin").show();

                                    } else {

                                        $('ul.list-dci-title').append('<li data-idfiche="' + data.idFiche + '" data-iddci="' + stats_partial[0] + '" data-idnc="' + stats_partial[1] + '"  ><a class="remove_dci"><span class="fa fa-close"></span></a>' + data.libelleDci + '</li>');
                                        if (isNomCommercial) {
                                            $(".btn_ncdci").html(renderedBtnNCDCI);
                                            $("ul.list-dci-title li[data-idfiche='" + data.idFiche + "']").addClass('toshow');
                                            $(".list_voies_admin").hide();
                                        }

                                    }


                                    $(".list-dci-title").trigger('contentChanged');
                                    $("#search-field").select2('val', ''); // réinitialisation du champs


                                    // getFiche(data.idFiche);

                                }
                            }
                        }).always(function () {
                            $('#loader').hide();
                        });
                    }

                }); //Fin select2 Change
                $("#search-field").data("select2").on("results:message", function () {
                    this.dropdown._positionDropdown();
                });
            }
        },
        // About us page, note the change from about-us to about_us.
        'page_template_template_licence': {
            init: function () {
                // JavaScript to be fired on the about us page
            },
            finalize: function () {
                var licenceFinale = {};

                function validateField() {
                    jQuery.extend(jQuery.validator.messages, {
                        required: "Champs requis.",
                        // remote: "Please fix this field.",
                        email: "Email invalid",
                        // url: "Please enter a valid URL.",
                        // date: "Please enter a valid date.",
                        // dateISO: "Please enter a valid date (ISO).",
                        // number: "Please enter a valid number.",
                        // digits: "Please enter only digits.",
                        // creditcard: "Please enter a valid credit card number.",
                        // equalTo: "Please enter the same value again.",
                        // accept: "Please enter a value with a valid extension.",
                        maxlength: jQuery.validator.format("Le champs doit comporter au maximum {0} caractères."),
                        minlength: jQuery.validator.format("Le champs doit comporter au minimum {0} caractères."),
                        // rangelength: jQuery.validator.format("Please enter a value between {0} and {1} caractères long."),
                        // range: jQuery.validator.format("Please enter a value between {0} and {1}."),
                        // max: jQuery.validator.format("Please enter a value less than or equal to {0}."),
                        // min: jQuery.validator.format("Please enter a value greater than or equal to {0}.")
                    });

                    var validator = $("#user_invoice_data").validate();
                    var result = validator.form({
                        lang: 'fr',
                        errorClass: 'error help-inline',
                    });

                    return result;


                }

                // $('#go-paypal').addClass('disabled');
                $(".checkform").click(function (e) {
                    isValid = validateField();
                    console.log(isValid);
                    if (isValid) {
                        return true;
                    } else {
                        e.preventDefault();
                        console.log('failed');
                        if ($('.msg-error-form').length === 0) {
                            $('#licence-invoice #select-btn-licence').parent().append('<span class="msg msg-error-form">Le formulaire comporte des erreurs.</span>');
                        }
                        return false;
                    }
                });

                //On choisit quel bouton on affiche (free licence ou paiement paypal)
                $(document).on('click', '#select-btn-licence', function (event) {

                    event.preventDefault();
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'confirmer_return_btn'
                        },
                        success: function (data) {
                            // console.log('btn to show');
                            // console.log(data);
                            $('.btn-achat-licence').html(data.btn);
                        }
                    });

                    /* Act on the event */
                });


                $(document).on('click', '#save_info_licence', function (event) {
                    event.preventDefault();
                    // console.log('Save info');
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            form: $('#user_invoice_data').serialize(),
                            action: 'user_info_invoice',
                            nonce: $('#user_invoice_data').data('nonce')
                        },
                        success: function (data) {
                            $('input[name=custom]').val(data);
                            $('#go-paypal').removeClass('disabled');
                            // alert(data);
                            // console.log(data);
                        }
                    });

                });



                $(document).on('click', '#go-paypal', function (event) {
                    if (!$(this).hasClass('disabled')) {
                        $('#form-paypal').submit();
                    } else {
                        alert("Impossible de payer pour l'instant.");
                    }
                    /* Act on the event */
                });

                //On gère les titre des section (Les TABS) les tabs change tout seul avec les events bootstrap
                $(document).on('click', '.btn-page', function (event) {
                    event.preventDefault();
                    // console.log('change page');
                    var tab = $(this).data('activetab');
                    // console.log(tab);
                    $('.cartbread').removeClass('active');
                    $("." + tab).addClass("active");
                });




                $('#loader').show();
                $.ajax({
                    url: gpr.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'get_licence',
                        nonce: $('#nonce').val()
                    },
                    success: function (data) {
                        var rendererLicence = '';
                        $.each(data, function (index, val) {
                            var tplLicence = $('#tpl-licences').html();
                            rendererLicence = rendererLicence + Mustache.render(tplLicence, val);
                        });

                        $(".licences-list").html(rendererLicence);

                        $('input[type=radio]').iCheck({
                            checkboxClass: 'icheckbox_square-blue',
                            radioClass: 'iradio_square-blue'

                        }).on('ifChecked', function (event) {
                            // console.log( $.trim($(this).closest('label').text()) );
                            $('.montant').html($(this).data('price'));

                            $('input[name=amount]').val($(this).data('price'));

                            licenceFinale.price = $(this).data('price');

                            //On met a jour le formualire de l'utilisateur
                            $('input[name=idlicence]').val($(this).val());

                            //On met a jour le formualire paypal
                            var item_name = $.trim($(this).closest('label').text());
                            $('input[name=item_name]').val(item_name);
                            $('.recap-libelle').html(item_name);

                            $('#licence-basket .btn-page').removeClass('disabled');

                        });
                    }
                });

                $(document).on('click', '#free_licence', function (event) {
                    // console.log('FL');
                    var _wpnonce = $(this).data('nonce');
                    // console.log(_wpnonce);
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'confirmer_licence_gratuite',
                            form: $('#user_invoice_data').serialize(),
                            nonce: _wpnonce,
                        },
                        success: function (data) {
                            if (data.hasOwnProperty('success')) {
                                $('.gpr-buy').html("<h2>Votre licence a bien été activé !</h2><p>Vous pouvez désormais consulter le siteGPR dans son intégralité.</p>");
                            } else {
                                $('.gpr-buy').html("Une erreur est survenue. Veuillez nous en excuser et prendre contact avec nous.");

                            }
                        }
                    });

                });
                //Si la licence est gratuite car code promo 100% de réduction, montant == 0€ :
                $(document).on('click', '#free_licence_codepromo', function (event) {
                    // console.log('FL');
                    var _wpnonce = $(this).data('nonce');
                    // console.log(_wpnonce);
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'licence_codepromo_gratuite',
                            form: $('#user_invoice_data').serialize(),
                            nonce: _wpnonce,
                        },
                        success: function (data) {
                            console.log('data');
                            if (data.hasOwnProperty('success')) {
                                $('.gpr-buy').html("<h2>Votre licence a bien été activée !</h2><p>Vous pouvez désormais consulter le siteGPR dans son intégralité.</p>");
                            } else {
                                $('.gpr-buy').html("Une erreur est survenue. Veuillez nous en excuser et prendre contact avec nous.");

                            }
                        }
                    });

                });


                $(document).on('click', '#free_licence', function (event) {
                    // console.log('FL');
                    var _wpnonce = $(this).data('nonce');
                    // console.log(_wpnonce);
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'confirmer_licence_gratuite',
                            form: $('#user_invoice_data').serialize(),
                            nonce: _wpnonce,
                        },
                        success: function (data) {
                            if (data.hasOwnProperty('success')) {
                                $('.gpr-buy').html("<h2>Votre licence a bien été activé !</h2><p>Vous pouvez désormais consulter le siteGPR dans son intégralité.</p>");
                            } else {
                                $('.gpr-buy').html("Une erreur est survenue. Veuillez nous en excuser et prendre contact avec nous.");

                            }
                        }
                    });

                });

                function saveUserLicenceChoice(idLicence, idCodePromo) {
                    // console.log('Save user choice');
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            nonce: $('#nonce').val(),
                            action: 'save_user_licence_choice',
                            codePromo: idCodePromo,
                            licence: idLicence
                        },
                        success: function (data) {
                            // // console.log(data);
                        }
                    });
                }
                $(document).on('click', '#savelicence', function (event) {

                    event.preventDefault();
                    idLicence = $(".checked input[name=licence]").val();
                    licenceFinale.idLicence = idLicence;
                    licenceFinale.reduc = $('input[name=reduc]').val();

                    saveUserLicenceChoice(idLicence, $('input[name=reduc]').val());

                });

                $(document).on('click', '#code-promo', function (event) {
                    event.preventDefault();
                    /* Act on the event */

                    idLicence = $(".checked input[name=licence]").val();

                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            nonce: $('#nonce').val(),
                            action: 'check_code_promo',
                            codePromo: $('input[name=reduc]').val(),
                            licence: idLicence,
                        },
                        success: function (data) {
                            var rendererLicence = '';
                            // console.log(data);

                            if (data.error === true) {

                                $('.msg-montant').html(data.message).show();
                                $('.msg-montant').addClass('error');
                                $('.montant').html($('.checked').data('price'));

                            } else {
                                // console.log(data);
                                $('.msg-montant').removeClass('error');
                                $('.msg-montant').html(data.message).show();
                                $('.montant').html(data.newPrice + ' ' + data.devise);
                                $('input[name=amount]').val(data.newPrice);

                            }

                        }
                    });

                });
            }
        },
        // validation de votre email
        'page_template_template_validate_email': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {

                $('#form_validate').on('click', function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    $this.button('loading');
                    $('.result-msg div').hide();
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: $("form#validate_email").serializeArray(),
                        success: function (data) {
                            if (data.error === true) {
                                $('.result-msg .failed').html(data.msg).show('fast');
                            } else {
                                document.location.href = data.url_redirection;
                            }
                        }
                    }).always(function () {
                        $this.button('reset');
                    });

                    // var data = $("#validate_email :input").serializeArray();
                    // console.log(data);
                });

                $('#send_email').on('click', function (e) {
                    e.preventDefault();
                    var nonce = $(this).data('nonce');
                    // console.log( nonce );

                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            'action': 'email_conf',
                            'nonce': nonce,
                        },
                        success: function (data) {
                            // console.log(data);
                            $('.send-email-info').html('<div class="result-msg"><div class="success success-email-send">' + data.msg + '</div></div>');
                            $('.result-msg .success-email-send').show();
                        }
                    });

                });
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // Liste des documents
        'page_template_template_page_perso': {
            init: function () {

            },
            finalize: function () {
                $('#loader').show();
                $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'get_documents',
                            nonce: $('#_wpnonce').val(),
                        },
                        success: function (data) {
                            if (typeof data.error === 'undefined') {
                                var tplDocuments = $('#template_list_documents').html();
                                var listDocumentsRenderer = '';
                                $.each(data, function (i, item) {
                                    //console.log(item);
                                    listDocumentsRenderer = listDocumentsRenderer + Mustache.render(tplDocuments, item);
                                });

                                $(".list-documents").html(listDocumentsRenderer);

                            } else {
                                $('.msg-no-result').show();
                            }
                        }
                    })
                    .done(function () {
                        $('#loader').hide();
                    });

            }
        },

        'page_template_template_reset_password': {
            init: function () {

            },
            finalize: function () {
                $(document).on('click', '#submit-reset-password', function (event) {
                    event.preventDefault();
                    //console.log('reset');
                    $('.msg').html('').removeClass('msg-success msg-error').hide();
                    $this = $(this);

                    $this.button('loading');
                    var email = $('#email').val();
                    var _wpnonce = $('#_wpnonce').val();

                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'reset_password_email',
                            mail: email,
                            nonce: _wpnonce
                        },
                        success: function (data) {
                            if (data.hasOwnProperty('success')) {
                                $('.msg').html(data.success).addClass('msg-success').fadeIn('fast');
                                $this.button('reset');
                                //Reset buttton is asynchronous...
                                setTimeout(function () { //  short delay after reset
                                    $this.prop('disabled', true);
                                }, 50);

                            } else if (data.hasOwnProperty('error')) {
                                $('.msg').html(data.error).addClass('msg-error').fadeIn('fast');
                                $this.button('reset');
                            } else {
                                $('.msg').html('Une erreur est survenue.').fadeIn('fast');
                            }
                        }
                    });

                });

                /* ##################################################################################### */
                $(document).on('click', '#submit-new-password', function (event) {
                    event.preventDefault();
                    // console.log('reset');
                    $('.msg').html('').removeClass('msg-error msg-success').hide();
                    $this = $(this);

                    $this.button('loading');
                    var pwd1 = $('#pwd1').val();
                    var pwd2 = $('#pwd2').val();
                    var mail = $('#mail').val();
                    var rcode = $('#code').val();
                    var _wpnonce = $('#_wpnonce').val();

                    //// console.log('New pwd' + rcode);
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'new_password',
                            pwd1: pwd1,
                            pwd2: pwd2,
                            mail: mail,
                            code: rcode,
                            nonce: _wpnonce
                        },
                        success: function (data) {
                            if (data.hasOwnProperty('success')) {

                                $('#form-reset-pwd').remove();

                                $('.msg').html(data.success).addClass('msg-success').fadeIn('fast');
                                $this.button('reset');
                                //Reset buttton is asynchronous...
                                // $this.button('reset');
                                setTimeout(function () { //  short delay after reset
                                    $this.prop('disabled', true);
                                }, 200);

                            } else if (data.hasOwnProperty('error')) {

                                $('.msg').html(data.error).addClass('msg-error').fadeIn('fast');
                                $this.button('reset');


                            } else {
                                $('.msg').html('Une erreur est survenue.').fadeIn('fast');
                            }
                        }
                    });

                });



            }
        },
        //Reset du mot de passe depuis le profil
        'page_template_template_page_password': {
            init: function () {

            },
            finalize: function () {
                $(document).on('click', '#submit-change-password', function (event) {
                    event.preventDefault();
                    // console.log('reset');
                    $('.msg').html('').removeClass('msg-success msg-error').hide();
                    $this = $(this);

                    $this.button('loading');
                    var old_pwd = $('#oldpassword').val();
                    var new_pwd1 = $('#pwd1').val();
                    var new_pwd2 = $('#pwd2').val();
                    var _wpnonce = $('#_wpnonce').val();

                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'change_password',
                            nonce: _wpnonce,
                            op: old_pwd,
                            np1: new_pwd1,
                            np2: new_pwd2
                        },
                        success: function (data) {
                            if (data.hasOwnProperty('success')) {

                                $('.msg').html(data.success).addClass('msg-success').fadeIn('fast');
                                $this.button('reset');
                                //Reset buttton is asynchronous...
                                setTimeout(function () { //  short delay after reset
                                    $this.prop('disabled', true);
                                }, 50);

                            } else if (data.hasOwnProperty('error')) {
                                $('.msg').html(data.error).addClass('msg-error').fadeIn('fast');
                                $this.button('reset');
                            } else {
                                $('.msg').html('Une erreur est survenue.').fadeIn('fast');
                            }
                        }
                    });

                });


            }
        },

        'page_template_template_recherche_grossesse': {
            init: function () {

                //on initialise les stats.
                var stats = {};
                var globalDci;

                function getFiche(idFiche) {
                    //Loader
                    // $('#loader').show().slideTo({target:'.fiche_dci'});
                    // console.log('id_fiche : ' + idFiche);
                    $('#loader').show();
                    stats.idFiche = idFiche;
                    var dfg = '';
                    var stadeGrossesse = '1';
                    if ($('.btn-grossesse.active').length) {
                        stadeGrossesse = $('.btn-grossesse.active').data('value');
                        stats.periodeGrossesse = stadeGrossesse;
                    }

                    $.ajax({

                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            idFiche: idFiche,
                            //_wpnonce : $('#_wpnonce').val(),
                            stade: stadeGrossesse,
                            action: 'get_fiche_grossesse'
                        },
                        success: function (data) {
                            if (data.disconnected) {
                                logOutUser();
                            }
                            //MUSTACHE.JS

                            if (isNaN(idFiche)) {
                                $(".fiche_dci").html('<h2>' + gpr.no_result + '<h2>');
                                return;
                            } else {
                                var templateFiche = $('#template_search_fiche').html();
                                var rendererFiche = Mustache.render(templateFiche, {
                                    'fields': data.fields[0],
                                    'btn_effets_renaux': false,
                                    'idFiche': idFiche
                                });
                                if (data.msg !== '') {
                                    $(".fiche_dci").html(data.msg);
                                }

                                $(".fiche_dci").append(rendererFiche).fieldHeight();

                                $(".btn-grossesse").removeClass('info-success info-warning');
                                $('.m').removeClass('visible-msg').html('');

                                if (data.r === 'oui') {
                                    $('.btn-grossesse.active').addClass('info-success').find('.m').html('OUI').addClass("visible-msg");
                                } else if (data.r === 'non') {
                                    $('.btn-grossesse.active').addClass('info-warning').find('.m').html('NON').addClass("visible-msg");
                                }
                            }


                            //On envoie les stats de consultation
                            // console.log(stats);
                            s = JSON.stringify(stats);
                            $.ajax({
                                url: gpr.ajaxurl,
                                type: 'POST',
                                data: {
                                    action: 'stats_recherche_grossesse',
                                    statistiques: s
                                }
                            });

                        }
                    }).always(function () {
                        // On remonte au niveau de la recommendation
                        $('html, body').animate({
                            scrollTop: $('.btns_dialyse').offset().top - 35
                        }, 600);

                        $('#loader').hide();
                    });
                }

                //Format de la ligne Select2 en fonction du type renvoyé
                function formatDCI(dci) {
                    // console.log(dci);
                    if (!dci.id) {
                        return dci.text;
                    }
                    if (dci.type === 'nom_commercial') {
                        return '' + dci.text + '';
                    } else {
                        return dci.text;
                    }
                }

                var language_translation = {
                    inputTooShort: function (args) {
                        // args.minimum is the minimum required length
                        // args.input is the user-typed text
                        return "Veuillez saisir au moins 2 caractères";
                    },
                    // inputTooLong: function(args) {
                    //   // args.maximum is the maximum allowed length
                    //   // args.input is the user-typed text
                    //   return "You typed too much";
                    // },
                    errorLoading: function () {
                        return "";
                    },
                    loadingMore: function () {
                        return "";
                    },
                    noResults: function () {
                        return gpr.btn_no_result;
                    },
                    searching: function () {
                        return "Recherche en cours...";
                    },
                    maximumSelected: function (args) {
                        // args.maximum is the maximum number of items the user may select
                        return "";
                    }
                };

                $("#search-field").select2({
                    // allowClear: true,
                    minimumResultsForSearch: -1,
                    minimumInputLength: 2,
                    selectOnClose: true,
                    // language: gpr.language,
                    language: language_translation,
                    // tags: true,
                    allowClear: true,
                    placeholder: gpr.chooseDci,
                    theme: "bootstrap",
                    ajax: {
                        url: gpr.ajaxurl,
                        delay: 100,
                        cache: true,
                        dataType: 'json',
                        data: function (params) {
                            var query = {
                                q: params.term,
                                action: 'search_med',
                                _wpnonce: $('#_wpnonce').val()
                            };
                            return query;
                        },
                        processResults: function (data, params) {
                            if (data.disconnected) {
                                logOutUser();
                            }
                            params.page = params.page || 1;
                            $('.results_dci div').html('');
                            return {
                                results: data.content,
                                pagination: {
                                    more: (params.page * 30) < data.total_count
                                }
                            };
                        },
                    },
                    cache: true,
                    escapeMarkup: function (markup) {
                        return markup;
                    }, // let our custom formatter work
                    // templateResult: formatDCI, // omitted for brevity, see the source of this page
                    // templateSelection: formatDCISelected // omitted for brevity, see the source of this page

                }).on("change", function (e) {
                    // console.log('GROSSESS CHANGE');
                    // return;
                    stats = {};
                    stats.effetsRenaux = false;

                    $('#loader').show();

                    $('.libelle_dci, .btns_dialyse, .btns_voie, .fiche_dci ').html('').show();
                    id = this.value;
                    if (id === '') {
                        $('#loader').hide();
                        return;
                    }

                    var type = 'dci';

                    //On récupère le texte du select pour le comparé au nom de la DCI afin de savori si nom commercial ou DCI pour afficher éventuellement le bouton
                    var nc = '';
                    var nc_value = $("#search-field").select2('data');
                    nc = nc_value[0].text;
                    // console.log(this.value);

                    //On vérifie si c'est un nom commercial (plusieurs id PIPE avec "|" : 125|589 ):
                    // partie 0 = idNomCommercialDci
                    // partie 1 = idDci
                    if (this.value.indexOf('|') > -1) {

                        ids = this.value.split('|');
                        id = ids[1];
                        // console.log(ids);
                        stats.idNc = parseInt(ids[0]);
                        stats.idDci = parseInt(ids[1]);

                    } else {
                        stats.idDci = parseInt(id);
                    }

                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            _wpnonce: $('#_wpnonce').val(),
                            id: id,
                            type: type,
                            action: 'get_dci'
                        },
                        success: function (data) {
                            if (data.disconnected) {
                                logOutUser();
                            }
                            // console.log('AJAX SUCCESS');
                            // console.log(data);
                            if (data.error === true) {
                                //On affiche le block aucun résultat;
                                var tplNoResult = $('#template_search_noresult').html();
                                $('.fiche_dci').html(Mustache.render(tplNoResult, data));
                            } else {
                                // console.log(data.libelleDci + ' | ' + nc )
                                // On affiche la pub DCI si besoin;
                                // console.log(data.displayPub);
                                if (data.displayPub) {
                                    if (data.displayPub.idPub != null) {
                                        $('#sidebar-ad-slider').addSlidePubDci({
                                            id: data.displayPub.idPub,
                                            link: data.displayPub.link,
                                            nonce: data.displayPub.nonce,
                                            durationPub: data.displayPub.duration,
                                        });
                                    }
                                }


                                // MUSTACHE.JS  Bouton dialyse DFG HDDV , etc.
                                var templateBtnDialyse = $('#template_search_dialyse').html();
                                var renderedBtnDialyse = Mustache.render(templateBtnDialyse, data);

                                // MUSTACHE.JS bouton des voies
                                var templateBtnVoie = $('#template_search_voie').html();
                                var renderedBtnVoie = Mustache.render(templateBtnVoie, data);
                                // console.log(renderedBtnVoie);
                                // console.log(data);

                                var type_search = $('#search_type').val();

                                //console.log(renderedBtnVoie);

                                // console.log(data.libelleDci + '+' + nc);
                                // Le nom sélectionné != du libellé DCI donc on a un nom commercial, et on affiche le bouton
                                if (data.libelleDci !== nc) { // Nom commercial
                                    console.log('ici');
                                    $('h1.libelle_dci').html(data.libelleDci).hide();

                                    var templateBtnNCDCI = $('#template_btn_ncdci').html();
                                    var renderedBtnNCDCI = Mustache.render(templateBtnNCDCI, {
                                        'nom_commercial': nc,
                                        'dci': data.libelleDci
                                    });

                                    $(".btn_ncdci").html(renderedBtnNCDCI);
                                    $(".btns_dialyse").html(renderedBtnDialyse).hide();

                                    if (!data.indication && !data.voiesAdmin) {
                                        // getFiche(data.idFiche);

                                    } else {
                                        $(".btns_voie").html(renderedBtnVoie);
                                    }


                                } else {
                                    $('h1.libelle_dci').html(data.libelleDci).show();

                                    // $(".btns_dialyse").html(renderedBtnDialyse).slideTo({target :'.btns_dialyse'});
                                    $(".btns_dialyse").html(renderedBtnDialyse);
                                    if (!data.indication && !data.voiesAdmin) {
                                        // getFiche(data.idFiche);
                                    } else {
                                        $(".btns_voie").html(renderedBtnVoie);
                                    }

                                }

                                //On active la fonctionalité de  tooltip sur la DFG :
                                $('#dfg[data-toggle="tooltip"]').tooltip({
                                    trigger: 'manual'
                                });

                            }
                        }
                    }).always(function () {
                        $('#loader').hide();
                    });

                }); //Fin select2 Change
                $("#search-field").data("select2").on("results:message", function () {
                    this.dropdown._positionDropdown();
                });
                $(document).on('click', '.btn-nctodci', function (event) {
                    event.preventDefault();
                    // $("h1.libelle_dci, .btns_dialyse, .btns_voie, .fiche_dci, .list_voies_admin").show().slideTo({target:'.btns_dialyse'});
                    // $("h1.libelle_dci, .btns_dialyse, .btns_voie, .fiche_dci, .list_voies_admin").show();
                    $("h1.libelle_dci, .btns_dialyse").show();
                    if ($('.list-btn-voies li').length === 0) {
                        // Lorsqu'on a une DCI qui n' pas de fiche ex : Diffu K
                        // $('.list_voies_admin h2').html(gpr.no_result);
                    }
                });

                //Affiche la fiche btn_standard // et on scroll ver la recommandation
                $(document).on('click', '.get_fiche', function (event) {
                    event.preventDefault();

                    var displayNext = false;

                    if ($(this).hasClass('btn-dfg')) {
                        displayNext = $(this).checkDfg();
                    } else {
                        displayNext = true;
                    }

                    if (displayNext) {

                        $(".get_fiche").removeClass('active');
                        $(this).addClass('active');
                        $(".fiche_dci").html('');
                        var idFiche = $(this).data('idfiche');
                        getFiche(idFiche);
                    }
                });

            }
        },


    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
